import qs from 'qs'

export function getDateYMD () {
  const current = new Date()
  const y = current.getFullYear()
  let MM = current.getMonth() + 1
  let dd = current.getDate()

  MM = MM < 10 ? `0${MM}` : MM
  dd = dd < 10 ? `0${dd}` : dd

  return `${y}${MM}${dd}`
}

/**
 *  返回今天和最近7天
 */
export function getTodayAndLast7Day () {
  return [getDay(-7), getDay(0)]
}

// 小于10加0
function doHandleLessThen10 (value) {
  let m = value
  if (value < 10) {
    m = '0' + value
  }
  return m
}

// 0: 当天  正数:加sum天  负数: 减sum天
function getDay (sum) {
  const today = new Date()

  const targetDay = today.getTime() + 1000 * 60 * 60 * 24 * sum

  today.setTime(targetDay)

  const tYear = today.getFullYear()
  let tMonth = today.getMonth()
  let tDate = today.getDate()
  tMonth = doHandleLessThen10(tMonth + 1)
  tDate = doHandleLessThen10(tDate)
  return tYear + '-' + tMonth + '-' + tDate
}

/**
 * 下载方法
 * @param url 下载接口地址
 * @param data 请求数据
 * */
export const downloadToTagByA = function (url, data) {
  const downloadForm = document.createElement('form')
  downloadForm.style = 'display:none;'
  downloadForm.method = 'get'
  downloadForm.action = window.gConfig.uploadURL + url + '?' + qs.stringify(data)
  document.body.appendChild(downloadForm)
  downloadForm.submit()
  document.body.removeChild(downloadForm)
}

export default {
  // 基础接口地址
     baseURL: operatingEnvironment(),
  // baseURL: 'https://www.chengxuyuancc.com:1996', 
  // 黄
  // baseURL: 'http://localhost:8088'
  // 上传文件接口地址
  // uploadURL: 'http://192.168.10.112:8080'
}

console.info('运行环境->',operatingEnvironment());
//运行环境
function operatingEnvironment() {
	//开发环境
    if (process.env.NODE_ENV === "development"){ 
		//this.baseURL = 'http://localhost:8088'
		return 'https://localhost:8088';  
	} 
	//测试环境，"192.168"根据实际情况而定
    else if (window.location.href.includes('192.168')){ 
		//this.baseURL = '192.168'
		return 'test'; 
	}else{
		//线上环境
		//this.baseURL = 'http://www.chengxuyuancc.com:1996'
		return 'https://www.chengxuyuancc.com/api'
	}       
}
